import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { Subscription, combineLatest } from 'rxjs';
import { Product } from '../../core/models/product.model';
import { ProductService } from '../../core/services/product.service';

@Component({
  selector: 'app-product-detail',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './product-detail.component.html',
  styleUrls: ['./product-detail.component.scss'],
})
export class ProductDetailComponent implements OnDestroy {
  product: Product | null = null;
  childProducts: Product[] = [];
  relatedProducts: Product[] = [];
  isLoading = true;
  productNotFound = false;
  private readonly subscription: Subscription;

  constructor(
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly route: ActivatedRoute,
    private readonly productService: ProductService,
  ) {
    this.subscription = combineLatest([this.route.paramMap, this.productService.products$]).subscribe(
      ([paramMap, products]) => {
        const productId = paramMap.get('productId');
        const selectedProduct = products.find((product) => product.id === productId && product.status === 'active');

        if (!selectedProduct) {
          this.product = null;
          this.childProducts = [];
          this.relatedProducts = [];
          this.isLoading = false;
          this.productNotFound = true;
          this.changeDetectorRef.detectChanges();
          return;
        }

        const parentProduct =
          selectedProduct.type === 'child'
            ? products.find((product) => product.id === selectedProduct.parentId) ?? selectedProduct
            : selectedProduct;

        this.product = parentProduct;
        this.childProducts = products
          .filter((product) => product.type === 'child' && product.parentId === parentProduct.id && product.status === 'active')
          .sort((a, b) => a.displayOrder - b.displayOrder || a.name.localeCompare(b.name));
        this.relatedProducts = products
          .filter(
            (product) =>
              product.type === 'parent' &&
              product.status === 'active' &&
              product.id !== parentProduct.id &&
              product.category === parentProduct.category,
          )
          .sort((a, b) => a.displayOrder - b.displayOrder || a.name.localeCompare(b.name))
          .slice(0, 3);
        this.isLoading = false;
        this.productNotFound = false;
        this.changeDetectorRef.detectChanges();
      },
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  trackByProduct(_: number, product: Product): string {
    return product.id;
  }
}
